// extracted by mini-css-extract-plugin
export default {"tabs":"Staff_tabs__hULFR","link":"Staff_link__hrNxw","active":"Staff_active__hWA2O"};